<template>
    <div class="sign-list-box">
        <app-loading :loaded="loaded"></app-loading>
        <div class="sign-list">
            <div v-for="item in dataList" :key="item.id" @click="toDetail(item)">
                <div>
                    <span>保单号</span>
                    <span>{{ item.policyNo }}</span>
                </div>
                <div>
                    <span>产品名称</span>
                    <span>{{ item.productName }}</span>
                </div>
                <div>
                    <span>投/被保人</span>
                    <span>{{ item.policyerName }}/{{ item.insuranceName }}</span>
                </div>
                <div>
                    <span>业务员</span>
                    <span>{{ item.salesmanName }}</span>
                </div>
                <van-icon name="arrow" class="detail-icon" />
                <img src="@static/images/filled.png" v-if="item.isFillSignInfo == '1'" class="filled" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
import loading from '@/components/loading';
export default {
    components: {
        'app-loading': loading
    },
    props: {},
    data() {
        return {
            dataList: [],
            loaded: false
        };
    },
    watch: {},
    computed: {},
    methods: {
        getList() {
            this.loaded = false;
            this.$http({
                type: 'GET',
                url: '/api/content/queryPaperPolicySignInfoList',
                data: {
                    sign: this.$route.query.sign
                }
            })
                .then(res => {
                    this.loaded = true;
                    if (res.data?.length) {
                        res.data.forEach(item => {
                            if (item.signDate) {
                                item.signDate = item.signDate.split(' ')[0];
                            }
                        });
                        this.dataList = res.data;
                    }
                })
                .finally(() => {
                    this.loaded = true;
                });
        },
        toDetail(obj) {
            sessionStorage.setItem('paperSignDetail', JSON.stringify(obj));
            if (obj.isFillSignInfo == '1') {
                //已填写
                this.$router.push({
                    path: '/apps/policys/paperPolicy/signDetail',
                    query: {
                        id: obj.id,
                        sign: this.$route.query.sign
                    }
                });
            } else {
                //未填写
                this.$router.push({
                    path: '/apps/policys/paperPolicy/signDetailEdit',
                    query: {
                        id: obj.id,
                        sign: this.$route.query.sign
                    }
                });
            }
        }
    },
    created() {
        this.getList();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.sign-list-box {
    min-height: 100vh;
    background-color: #fff;
    padding: 30px 30px 0;
    overflow: auto;
    .sign-list {
        font-size: 24px;
        > div {
            position: relative;
            padding: 20px;
            border: 1px solid #e5e5e5;
            margin-bottom: 20px;
            border-radius: 8px;
            > div {
                display: flex;
                align-items: center;
                margin-bottom: 10px;
                span:first-child {
                    color: #999;
                    flex: 0 0 25%;
                }
                &:last-child {
                    margin-bottom: 0;
                }
            }
            .detail-icon {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                right: 20px;
            }
            .filled {
                position: absolute;
                top: 0;
                right: 0;
                width: 80px;
                height: 80px;
            }
        }
    }
}
</style>

<!-- http://localhost:8080/apps/policys/paperPolicy/signList?sign=v2_3db63a01edaba1c8fd8690da63b8e44f -->